import { render } from "./BasicButton.vue?vue&type=template&id=73d36b50"
import script from "./BasicButton.vue?vue&type=script&lang=js"
export * from "./BasicButton.vue?vue&type=script&lang=js"

import "./BasicButton.vue?vue&type=style&index=0&id=73d36b50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__